<div class="row" *ngIf="showRecomendations">
  <div class="col-12 py-3 px-6 text-sm bg-white border-t border-bxBlue">
    <div class="row text-center">
      <div class="col-12"> Las cifras de operativa del cliente que se mostraran son reflejo instantaneo del proceso de
        consulta.
      </div>
      <div class="col-12">
        Si tiene alguna duda al respecto de estas cifras favor de comunicarse con su promotor o a la dirección de
        Promoción
        de</div>
      <div class="col-12">CASA DE BOLSA VE POR MAS S.A. DE C.V. GRUPO FINANCIERO VE POR MAS</div>
      <div class="col-12"> Se recomienda por seguridad y para una funcionalidad correcta, usar un navegador que respete
        los estandares de la W3C</div>
    </div>
  </div>
</div>

<div class="row bg-green py-1.5 text-base">
  <ul class="links-info gap-x-4">
    <li> <a (click)="goWeb(0)">Preguntas Frecuentes</a> </li>
    <li> <a (click)="goWeb(1)">Comisiones</a> </li>
    <li> <a [routerLink]="['/nosotros/horarios']" [skipLocationChange]="hiddenPath">Horarios</a> </li>
    <li> <a (click)="goWeb(2)">Privacidad</a> </li>
    <li> <a (click)="goWeb(3)">Seguridad</a> </li>
    <li> <a (click)="goWeb(4)">Contáctanos</a> </li>
    <li> <a (click)="goWeb(5)">Resumen fondos</a> </li>
  </ul>
</div>